<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.fm.electrodePasteEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/electrodePastePara"><span>{{$t('tlt.fm.electrodePaste')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/electrodePasetParaEdit"><span>{{$t('tlt.fm.electrodePasteEdit')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('electrodePastePara')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('electrodePastePara')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.date')}}：</label>
                                <mmf-datepicker v-model="day"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.datetime')}}：</label>
                                <!-- <input class="form-control form-control-sm" type="time" v-model="time" name="time"> -->
                                <mes-time-picker v-model="time"></mes-time-picker>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.furnaceName')}}：</label>
                                <select class="form-control" v-model="furnaceNumber" v-validate="'required'" name="furnaceNumber">
                                        <option value="default">{{$t("lbl.basic.select.one")}}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                                </select>
                                <span v-show="errors.has('furnaceNumber')" class="lbl-obg">
                                    {{errors.first('furnaceNumber')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.additionA')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="additionA" name="additionA" v-validate="'required'">
                                <span v-show="errors.has('additionA')" class="lbl-obg">
                                    {{errors.first('additionA')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.additionB')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="additionB" name="additionB" v-validate="'required'">
                                <span v-show="errors.has('additionB')" class="lbl-obg">
                                    {{errors.first('additionB')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.additionC')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="additionC" name="additionC" v-validate="'required'">
                                <span v-show="errors.has('additionC')" class="lbl-obg">
                                    {{errors.first('additionC')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.electrodeNumberA')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="electrodeNumberA" name="electrodeNumberA" v-validate="'required'">
                                <span v-show="errors.has('electrodeNumberA')" class="lbl-obg">
                                    {{errors.first('electrodeNumberA')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.electrodeNumberB')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="electrodeNumberB" name="electrodeNumberB" v-validate="'required'">
                                <span v-show="errors.has('electrodeNumberB')" class="lbl-obg">
                                    {{errors.first('electrodeNumberB')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.electrodeNumberC')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="electrodeNumberC" name="electrodeNumberC" v-validate="'required'">
                                <span v-show="errors.has('electrodeNumberC')" class="lbl-obg">
                                    {{errors.first('electrodeNumberC')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.electrodeDownA')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="electrodeDownA" name="electrodeDownA" v-validate="'required'">
                                <span v-show="errors.has('electrodeDownA')" class="lbl-obg">
                                    {{errors.first('electrodeDownA')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.electrodeDownB')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="electrodeDownB" name="electrodeDownB" v-validate="'required'">
                                <span v-show="errors.has('electrodeDownB')" class="lbl-obg">
                                    {{errors.first('electrodeDownB')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.electrodeDownC')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="electrodeDownC" name="electrodeDownC" v-validate="'required'">
                                <span v-show="errors.has('electrodeDownC')" class="lbl-obg">
                                    {{errors.first('electrodeDownC')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pasteTempA')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pasteTempA" name="pasteTempA" v-validate="'required'">
                                <span v-show="errors.has('pasteTempA')" class="lbl-obg">
                                    {{errors.first('pasteTempA')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pasteTempB')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pasteTempB" name="pasteTempB" v-validate="'required'">
                                <span v-show="errors.has('pasteTempB')" class="lbl-obg">
                                    {{errors.first('pasteTempB')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pasteTempC')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pasteTempC" name="pasteTempC" v-validate="'required'">
                                <span v-show="errors.has('pasteTempC')" class="lbl-obg">
                                    {{errors.first('pasteTempC')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.liquidPasteA')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="liquidPasteA" name="liquidPasteA" v-validate="'required'">
                                <span v-show="errors.has('liquidPasteA')" class="lbl-obg">
                                    {{errors.first('liquidPasteA')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.liquidPasteB')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="liquidPasteB" name="liquidPasteB" v-validate="'required'">
                                <span v-show="errors.has('liquidPasteB')" class="lbl-obg">
                                    {{errors.first('liquidPasteB')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.liquidPasteC')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="liquidPasteC" name="liquidPasteC" v-validate="'required'">
                                <span v-show="errors.has('liquidPasteC')" class="lbl-obg">
                                    {{errors.first('liquidPasteC')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.solidPasteA')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="solidPasteA" name="solidPasteA" v-validate="'required'">
                                <span v-show="errors.has('solidPasteA')" class="lbl-obg">
                                    {{errors.first('solidPasteA')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.solidPasteB')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="solidPasteB" name="solidPasteB" v-validate="'required'">
                                <span v-show="errors.has('solidPasteB')" class="lbl-obg">
                                    {{errors.first('solidPasteB')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.solidPasteC')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="solidPasteC" name="solidPasteC" v-validate="'required'">
                                <span v-show="errors.has('solidPasteC')" class="lbl-obg">
                                    {{errors.first('solidPasteC')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.eastOffset')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="eastOffset" name="eastOffset" v-validate="'required'">
                                <span v-show="errors.has('eastOffset')" class="lbl-obg">
                                    {{errors.first('eastOffset')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.southOffset')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="southOffset" name="southOffset" v-validate="'required'">
                                <span v-show="errors.has('southOffset')" class="lbl-obg">
                                    {{errors.first('southOffset')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.westOffset')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="westOffset" name="westOffset" v-validate="'required'">
                                <span v-show="errors.has('westOffset')" class="lbl-obg">
                                    {{errors.first('westOffset')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.northOffset')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="northOffset" name="northOffset" v-validate="'required'">
                                <span v-show="errors.has('northOffset')" class="lbl-obg">
                                    {{errors.first('northOffset')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.eastAdjust')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="eastAdjust" name="eastAdjust" v-validate="'required'">
                                <span v-show="errors.has('eastAdjust')" class="lbl-obg">
                                    {{errors.first('eastAdjust')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.southAdjust')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="southAdjust" name="southAdjust" v-validate="'required'">
                                <span v-show="errors.has('southAdjust')" class="lbl-obg">
                                    {{errors.first('southAdjust')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.westAdjust')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="westAdjust" name="westAdjust" v-validate="'required'">
                                <span v-show="errors.has('westAdjust')" class="lbl-obg">
                                    {{errors.first('westAdjust')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.northAdjust')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="northAdjust" name="northAdjust" v-validate="'required'">
                                <span v-show="errors.has('northAdjust')" class="lbl-obg">
                                    {{errors.first('northAdjust')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.cylinderHeight')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="cylinderHeight" name="cylinderHeight" v-validate="'required'">
                                <span v-show="errors.has('cylinderHeight')" class="lbl-obg">
                                    {{errors.first('cylinderHeight')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.remark')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="remark" name="remark" v-validate="'required'">
                                <span v-show="errors.has('remark')" class="lbl-obg">
                                    {{errors.first('remark')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions, mapState,
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionExecution/smelting/ElectrodePastePara";
    import MmfDatepicker from '@/components/MmfDatepicker';
    import MesTimePicker from '@/components/MesTimePicker';
    import dimSearch from "@/components/MMFDimSearch";

    const {
        mapFields
    } = createHelpers({
        getterType: 'electrodePastePara/getField',
        mutationType: 'electrodePastePara/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
            this.$store.dispatch('electrodePastePara/loadLocations');
    },
    computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.electrodePastePara.locations,
            }),
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            MmfDatepicker,
            MesTimePicker,
            dimSearch
        }
};
</script>